import React from 'react';
import AppLayout from '../components/app/AppLayout';
import FocusFionaPlaceholder from '../components/app/FocusFionaPlaceholder';

function FionaPage() {
  return (
    <AppLayout>
      <FocusFionaPlaceholder />
    </AppLayout>
  );
}

export default FionaPage;








